import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function PartnerGymActionPopover(props) {
  const { onClickEditPermission, onClickEndConnection, onClose } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const PopoverRef = useRef(null);

  // 외부 클릭 시 닫기 //
  useEffect(() => {
    function onMouseDownOutside(e) {
      if (PopoverRef.current && !PopoverRef.current.contains(e.target)) onClose();
    }

    document.addEventListener('mousedown', onMouseDownOutside);

    return () => document.removeEventListener('mousedown', onMouseDownOutside);
  }, [onClose])

  return (
    <PopoverWrapper
      ref={PopoverRef}
      backgroundColor={theme.subBackground}
      borderColor={theme.primary}>
      <OptionItem
        hoverBg={theme.primary}
        hoverColor={theme.subBackground}
        onClick={onClickEditPermission}>
        <OptionText color={theme.primary}>{t('myStoreSetting.partnerGym.requestModal.editPermission')}</OptionText>
      </OptionItem>
      <OptionItem
        hoverBg={theme.primary}
        hoverColor={theme.subBackground}
        onClick={onClickEndConnection}>
        <OptionText color={theme.primary}>{t('myStoreSetting.partnerGym.requestModal.endConnection')}</OptionText>
      </OptionItem>
    </PopoverWrapper>
  );
}

const PopoverWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  margin-left: 8px;
  z-index: 10;

  display: flex;
  flex-direction: column;

  align-items: stretch;

  border: 1px solid ${props => props.borderColor};
  border-radius: 5px;

  background-color: ${props => props.backgroundColor};

  overflow: hidden;
`;

const OptionItem = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  height: 38px;
  padding: 0 10px;

  transition: background-color 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.hoverBg};
    }

    &:hover > p {
      color: ${props => props.hoverColor};
    }
  }
`;

const OptionText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0;

  white-space: nowrap;

  color: ${props => props.color};

  transition: color 0.3s ease-in-out;
`;
